export default {
  paged: {
    select: 'id,name,description,isActive',
    searchSelect: ['name', 'description'],
    orderBy: 'name',
  },
  item: {
    select: 'id,name,description,isActive',
  },
  itemDetail: {
    select: 'id,name,description,isActive,created,updated',
    expand: {
      userCreator: { select: 'fullName' },
      userModifier: { select: 'fullName' },
    },
  },
};
